<template>
    <div>
        <!--  Breadcrumb Area Start  -->  
        <div class="breadcrumb-area breadcrumb-bg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="breadcrumb-txt">
                            <h1>İLETİŞİME GEÇ</h1>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="breadcrumb-links">
                            <ul>
                                <li><a href="/">Ana sayfa</a></li>
                                <li><a href="#">İletişim</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="breadcrumb-overlay"></div>
        </div>
        <!--  Breadcrumb Area End  -->


        <!--   contact section start    -->
        <div class="contact-section">
            <div class="container">
                <!--  contact infos start  -->
                <div class="contact-infos">
                    <div class="row no-gutters">
                        <div class="col-lg-4 single-info-col">
                            <div class="single-info wow fadeInRight" data-wow-duration="1s">
                                <div class="icon-wrapper"><i class="fas fa-home"></i></div>
                                <div class="info-txt">
                                    <p>İsmet Paşa Mahallesi Küçük Sanayi Sitesi 21. Sokak No:20</p>
                                    <p>Merkez / Çanakkale</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 single-info-col">
                            <div class="single-info wow fadeInRight" data-wow-duration="1s" data-wow-delay=".2s">
                                <div class="icon-wrapper"><i class="fas fa-phone"></i></div>
                                <div class="info-txt">
                                    <p>0 (532) 453 60 25</p>
                                    <p>0 (542) 499 60 25</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 single-info-col">
                            <div class="single-info wow fadeInRight" data-wow-duration="1s" data-wow-delay=".4s">
                                <div class="icon-wrapper"><i class="far fa-envelope"></i></div>
                                <div class="info-txt">
                                    <p>
                                        <a style="color: #8c7f7f" href="mailto:info@tamir-hane.com">info@tamir-hane.com</a>
                                    </p>
                                    <p>
                                        <a style="color: #8c7f7f" href="mailto:tamir.hane17@gmail.com">tamir.hane17@gmail.com</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--  contact infos end  -->
                <!--  contact form and map start  -->
                <div class="contact-form-section">
                    <div class="row">
                        <div class="col-lg-6">
                            <h2 class="subtitle">İletişim Formu</h2>
                            <form id="contactForm" @submit="submitForm" method="POST">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-element"><input type="text" id="name" name="name" placeholder="Adınız Soyadınız"></div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-element"><input type="text" id="email" name="email" placeholder="Email Adresiniz"></div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-element"><input type="text" id="phone" name="phone" placeholder="Telefon"></div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-element"><input type="text" id="subject" name="subject" placeholder="Konu"></div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-element">
                                            <textarea id="message" name="message" cols="30" rows="10" placeholder="Mesajınız..."></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-element">
                                            <button type="submit" :disabled="submitButtonDisabled"><span>{{ submitButtonTitle }}</span></button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="col-lg-6">
                            <div class="map-wrapper">
                                <iframe
                                    width="100%"
                                    height="450"
                                    frameborder="0" style="border:0"
                                    src="https://www.google.com/maps/embed/v1/search?key=AIzaSyC0qKhFS4Hbn9Ay6OF8AXBDcqLVJ_y9VPg&q=40.1473541,26.4271688">
                                </iframe>
                            </div>
                        </div>
                    </div>
                </div>
                <!--  contact form and map end  -->
            </div>
        </div>
        <!--   contact section end    -->

        <!-- <b-button v-b-modal="'my-modal'">Show Modal</b-button> -->
        <b-modal id="my-modal" title="Uyarı" cancel-variant="false" ok-title="Tamam" >Tüm alanların doldurulması gereklidir!</b-modal>
        <b-modal id="my-modal-2" title="Mesajınız iletildi" cancel-variant="false" ok-title="Tamam" >Mesajınız iletildi. En kısa sürede sizinle iletişime geçeceğiz.</b-modal>
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';

export default {
    data() {
        return {
            submitButtonTitle: 'Gönder',
            submitButtonDisabled: false
        }
    },

    mounted() {
        // this.$bvModal.show('my-modal')
    },

    methods: {
        submitForm(e) {
            if (
                !$('#name').val() ||
                !$('#email').val() ||
                !$('#phone').val() ||
                !$('#subject').val() ||
                !$('#message').val()
            ) {
                this.$bvModal.show('my-modal');
                e.preventDefault();
                return false;
            }

            this.submitButtonDisabled = true;
            this.submitButtonTitle = 'Gönderiliyor';
            axios.post('/php/sendMail.php', $('#contactForm').serialize()).then(res => {
                this.submitButtonDisabled = true;
                this.submitButtonTitle = 'Gönder';
                this.$bvModal.show('my-modal-2');
            })

            e.preventDefault();
        }
    }
}
</script>
